<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/dashboard">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('/dashboard') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/bookings">
        <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('bookings') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('/bookings') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Biglietti</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/bookings/busy">
        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('bookings/busy') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('/bookings/busy') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Ombrelloni occupati</div>
      </Link>
    </div>
    <div class="mb-4" v-if="$page.props.auth.user.owner">
      <Link class="group flex items-center py-3" href="/config">
        <icon name="settings" class="mr-2 w-4 h-4" :class="isUrl('config') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('/config') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Configurazione</div>
      </Link>
    </div>
  </div>
</template>

<script>
import Icon from "@/Pages/Dashboard/Shared/Icon.vue";
import { Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(expectedPath) {
      const currentPath = window.location.pathname;

      // Handle empty string or '/dashboard' - both should match only dashboard
      if (expectedPath === '' || expectedPath === '/dashboard' || expectedPath === 'dashboard') {
        return currentPath === '/dashboard';
      }

      // Normalize expected path to always have leading slash
      const normalized = expectedPath.startsWith('/') ? expectedPath : `/${expectedPath}`;

      // Check if current path starts with expected path
      return currentPath.startsWith(normalized);
    },
  },
};
</script>
